<div class="notifications-list-dialog">
  <div class="notifications-dialog-header">
    <div class="notifications-dialog-title" cdkFocusInitial>
      {{'COMMON.notifications' | translate}}
      @if (unreadNotificationsCount; as counter) {
        ({{ counter }})
      }
    </div>

    <div class="dialog-header-buttons">
      <app-icon-button class="dialog-close-button" [ariaLabel]="'Close'" icon="x" (clicked)="closeDialog()"></app-icon-button>
    </div>
  </div>

  <div class="notifications">
    @if (notifications?.length) {
      <ng-scrollbar class="notifications-scrollbar" [class.has-scroll]="scrollbarRef?.adapter?.isVerticallyScrollable?.()" (scroll)="onNotificationsScroll($event)">
        <div class="notifications-list">
          @for (item of notifications; track item?.['@id']) {
            <div
              class="notification"
              [ngClass]="{ 'new-notification': !item.seen }"
              (click)="notificationNavigate(item)">
              <div class="notification-icon">
                <lib-icon [icon]="item?.relatedContent?.bundle | entityBundleIcon"></lib-icon>
              </div>
              <div class="notification-body">
                <h6 class="notification-title">
                  {{ item.message?.title }}
                </h6>
                <span class="notification-message">
                  {{ item.message?.text }}
                </span>
                <div class="notification-date">
                  <div class="new-indicator">
                    {{ 'COMMON.new' | translate }}
                  </div>
                  <div class="notification-delivered-time">
                    {{ item.deliveredAt | dateDiff }}
                  </div>
                </div>
              </div>
            </div>
          }
        </div>
      </ng-scrollbar>
    } @else {
      @if (!isLoading) {
        <app-list-empty-state
          class="notifications-empty-state"
          icon="tray"
          [title]="'NOTIFICATIONS.no_new_notications' | translate"
          [text]="'NOTIFICATIONS.notifications_will_show_up_here' | translate">
        </app-list-empty-state>
      } @else {
        <div class="notifications-list">
          @for (item of placeholders; track $index) {
            <div class="notification placeholder">
              <lib-skeleton-loader height="40px" width="40px" className="circle"></lib-skeleton-loader>
              <div class="notification-body">
                <lib-skeleton-loader height="22px" width="60%"></lib-skeleton-loader>
                <lib-skeleton-loader height="16px" width="80%"></lib-skeleton-loader>
                <lib-skeleton-loader height="12px" width="40%"></lib-skeleton-loader>
              </div>
            </div>
          }
        </div>
      }
    }
  </div>



</div>
